// IOL model list and optimised SRK/T A-constants.
// Source: IOL Exchange SRS, section 1.1.1 (workbook "Constants" sheet).
// These are optimised constants and may differ from the manufacturer nominal values.
//
// The form asks for the manufacturer first, then the model (Dante and Peter, 2 Nov). A
// model is still identified by its full name, manufacturer + model ("Alcon AcrySof IQ
// (SN60WF)"): the A-constant lookup, the request and the stored cases all use that name.
export const exchangeIOLModels = [
    {manufacturer: 'Alcon', model: 'AcrySof IQ (SN60WF)', aConstant: 119.0},
    {manufacturer: 'Alcon', model: 'Clareon Monofocal (SY60WF)', aConstant: 119.1},
    {manufacturer: 'B+L', model: 'enVista (MX60E)', aConstant: 119.1},
    {manufacturer: 'HOYA', model: 'Vivinex iSert (XY1)', aConstant: 118.9},
    {manufacturer: 'J&J', model: 'TECNIS 1-Piece (ZCB00)', aConstant: 119.3},
    {manufacturer: 'J&J', model: 'TECNIS Eyhance (ICB00)', aConstant: 119.3},
    {manufacturer: 'ZEISS', model: 'CT LUCIA (621P)', aConstant: 120.2},
    {manufacturer: 'Alcon', model: 'AcrySof Multipiece (MA60AC)', aConstant: 119.2},
    {manufacturer: 'B+L', model: 'SofPort AO (LI61AO)', aConstant: 118.7},
    {manufacturer: 'J&J', model: 'Sensar (AR40e)', aConstant: 118.7},
    {manufacturer: 'J&J', model: 'TECNIS 3-Piece (ZA9003)', aConstant: 119.1},
    {manufacturer: 'ZEISS', model: 'CT LUCIA (602)', aConstant: 117.7},
    {manufacturer: 'Alcon', model: 'Clareon PanOptix (CNWTT0)', aConstant: 119.1},
    {manufacturer: 'Alcon', model: 'Clareon Vivity (CNWET0)', aConstant: 119.2},
    {manufacturer: 'B+L', model: 'enVista Envy (EN)', aConstant: 119.5},
    {manufacturer: 'BVI/PhysIOL', model: 'FineVision (POD F)', aConstant: 118.95},
    {manufacturer: 'J&J', model: 'TECNIS Symfony (ZXR00)', aConstant: 119.3},
    {manufacturer: 'J&J', model: 'TECNIS PureSee (DEN00V)', aConstant: 119.3},
    {manufacturer: 'J&J', model: 'TECNIS Odyssey (DRN00V)', aConstant: 119.3},
    {manufacturer: 'J&J', model: 'TECNIS Synergy OptiBlue (DFR00V)', aConstant: 119.3},
    {manufacturer: 'ZEISS', model: 'AT LISA tri (839MP)', aConstant: 118.6},
].map((m) => ({...m, name: m.manufacturer + ' ' + m.model}));

export const exchangeIOLModelNames = exchangeIOLModels.map((model) => model.name);

// Alphabetical. The models of each keep the list's order, which groups them by kind
// (one-piece monofocal, three-piece, presbyopia-correcting).
export const exchangeIOLManufacturers = [...new Set(exchangeIOLModels.map((m) => m.manufacturer))]
    .sort((a, b) => a.localeCompare(b, 'en', {sensitivity: 'base'}));

export function getModelsOf(manufacturer){
    return exchangeIOLModels.filter((m) => m.manufacturer === manufacturer);
}

export function getAConstant(modelName){
    let model = exchangeIOLModels.find((m) => m.name === modelName);
    return (model)? model.aConstant.toFixed(2) : "";
}

// "IOL labeled toricity" of a toric implant (Dr. Buonsanti, 2 Nov): the cylinder printed on
// the lens, at the IOL plane, with the T2-T9 values toricaligner.com uses. "Other" lets the
// surgeon type a value that is not in the list.
export const OTHER_TORICITY = 'Other';
export const labeledToricities = [
    {value: '1.00', label: '1.00 D (T2)'},
    {value: '1.50', label: '1.50 D (T3)'},
    {value: '2.25', label: '2.25 D (T4)'},
    {value: '3.00', label: '3.00 D (T5)'},
    {value: '3.75', label: '3.75 D (T6)'},
    {value: '4.50', label: '4.50 D (T7)'},
    {value: '5.25', label: '5.25 D (T8)'},
    {value: '6.00', label: '6.00 D (T9)'},
    {value: OTHER_TORICITY, label: 'Other'},
];

// Reasons for exchange (SRS 1.1 / 1.3). Recorded, not used in the math.
export const exchangeReasons = [
    'Poor quality of vision',
    'Negative dysphotopsias',
    'Positive dysphotopsias',
    'Starbursts, glare or haloes',
    'Refractive surprise',
    'Other',
];
